module.exports = __webpack_public_path__ + "static/media/blue.0ff7bef5.svg";